// extracted by mini-css-extract-plugin
module.exports = {"view-profile-btn":"StudentTable_view-profile-btn__3ZIKJ","view-group-col":"StudentTable_view-group-col__2Es3q","table-heading":"StudentTable_table-heading__3YZqm"};